/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type SuggestionIcon =
  (typeof SuggestionIcon)[keyof typeof SuggestionIcon];

export const SuggestionIcon = {
  AlarmCheck: "AlarmCheck",
  AlarmMinus: "AlarmMinus",
  AlarmPlus: "AlarmPlus",
  BookTemplate: "BookTemplate",
  ClipboardEdit: "ClipboardEdit",
  ClipboardSignature: "ClipboardSignature",
  Code2: "Code2",
  Columns: "Columns",
  Edit3: "Edit3",
  FileCog2: "FileCog2",
  FileEdit: "FileEdit",
  FileSignature: "FileSignature",
  GitCommit: "GitCommit",
  Grid: "Grid",
  Inspect: "Inspect",
  Layout: "Layout",
  PanelBottomInactive: "PanelBottomInactive",
  PanelLeftInactive: "PanelLeftInactive",
  PanelRightInactive: "PanelRightInactive",
  PanelTopInactive: "PanelTopInactive",
  PenSquare: "PenSquare",
  Rows: "Rows",
  ShieldClose: "ShieldClose",
  Train: "Train",
  User2: "User2",
  UserCheck2: "UserCheck2",
  UserCircle: "UserCircle",
  UserCircle2: "UserCircle2",
  UserCog2: "UserCog2",
  UserMinus2: "UserMinus2",
  UserPlus2: "UserPlus2",
  UserSquare: "UserSquare",
  UserSquare2: "UserSquare2",
  UserX2: "UserX2",
  Users2: "Users2",
  Verified: "Verified",
  ActivitySquare: "ActivitySquare",
  AlertCircle: "AlertCircle",
  AlertOctagon: "AlertOctagon",
  AlertTriangle: "AlertTriangle",
  AreaChart: "AreaChart",
  ArrowDownCircle: "ArrowDownCircle",
  ArrowDownLeftFromCircle: "ArrowDownLeftFromCircle",
  ArrowDownLeftFromSquare: "ArrowDownLeftFromSquare",
  ArrowDownLeftSquare: "ArrowDownLeftSquare",
  ArrowDownRightFromCircle: "ArrowDownRightFromCircle",
  ArrowDownRightFromSquare: "ArrowDownRightFromSquare",
  ArrowDownRightSquare: "ArrowDownRightSquare",
  ArrowDownSquare: "ArrowDownSquare",
  ArrowLeftCircle: "ArrowLeftCircle",
  ArrowLeftSquare: "ArrowLeftSquare",
  ArrowRightCircle: "ArrowRightCircle",
  ArrowRightSquare: "ArrowRightSquare",
  ArrowUpCircle: "ArrowUpCircle",
  ArrowUpLeftFromCircle: "ArrowUpLeftFromCircle",
  ArrowUpLeftFromSquare: "ArrowUpLeftFromSquare",
  ArrowUpLeftSquare: "ArrowUpLeftSquare",
  ArrowUpRightFromCircle: "ArrowUpRightFromCircle",
  ArrowUpRightFromSquare: "ArrowUpRightFromSquare",
  ArrowUpRightSquare: "ArrowUpRightSquare",
  ArrowUpSquare: "ArrowUpSquare",
  AsteriskSquare: "AsteriskSquare",
  BarChart2: "BarChart2",
  BarChart3: "BarChart3",
  BarChart4: "BarChart4",
  BarChartBig: "BarChartBig",
  BarChartHorizontalBig: "BarChartHorizontalBig",
  BarChartHorizontal: "BarChartHorizontal",
  BarChart: "BarChart",
  BoxSelect: "BoxSelect",
  CandlestickChart: "CandlestickChart",
  CheckCircle2: "CheckCircle2",
  CheckCircle: "CheckCircle",
  CheckSquare2: "CheckSquare2",
  CheckSquare: "CheckSquare",
  ChevronDownCircle: "ChevronDownCircle",
  ChevronDownSquare: "ChevronDownSquare",
  ChevronLeftCircle: "ChevronLeftCircle",
  ChevronLeftSquare: "ChevronLeftSquare",
  ChevronRightCircle: "ChevronRightCircle",
  ChevronRightSquare: "ChevronRightSquare",
  ChevronUpCircle: "ChevronUpCircle",
  ChevronUpSquare: "ChevronUpSquare",
  CodeSquare: "CodeSquare",
  Contact2: "Contact2",
  DivideCircle: "DivideCircle",
  DivideSquare: "DivideSquare",
  DotSquare: "DotSquare",
  DownloadCloud: "DownloadCloud",
  EqualSquare: "EqualSquare",
  FileBarChart2: "FileBarChart2",
  FileBarChart: "FileBarChart",
  FileLineChart: "FileLineChart",
  FilePieChart: "FilePieChart",
  FilterX: "FilterX",
  Filter: "Filter",
  FormInput: "FormInput",
  FunctionSquare: "FunctionSquare",
  GanttChartSquare: "GanttChartSquare",
  GanttChart: "GanttChart",
  GaugeCircle: "GaugeCircle",
  Globe2: "Globe2",
  HelpCircle: "HelpCircle",
  HelpingHand: "HelpingHand",
  Home: "Home",
  IceCream2: "IceCream2",
  IceCream: "IceCream",
  Indent: "Indent",
  KanbanSquareDashed: "KanbanSquareDashed",
  KanbanSquare: "KanbanSquare",
  Laptop2: "Laptop2",
  Layers3: "Layers3",
  LibrarySquare: "LibrarySquare",
  LineChart: "LineChart",
  Loader2: "Loader2",
  MSquare: "MSquare",
  MenuSquare: "MenuSquare",
  Mic2: "Mic2",
  MinusCircle: "MinusCircle",
  MinusSquare: "MinusSquare",
  MoreHorizontal: "MoreHorizontal",
  MoreVertical: "MoreVertical",
  MousePointerSquareDashed: "MousePointerSquareDashed",
  MousePointerSquare: "MousePointerSquare",
  Outdent: "Outdent",
  Paintbrush2: "Paintbrush2",
  Palmtree: "Palmtree",
  ParkingCircleOff: "ParkingCircleOff",
  ParkingCircle: "ParkingCircle",
  ParkingSquareOff: "ParkingSquareOff",
  ParkingSquare: "ParkingSquare",
  PauseCircle: "PauseCircle",
  PauseOctagon: "PauseOctagon",
  PercentCircle: "PercentCircle",
  PercentDiamond: "PercentDiamond",
  PercentSquare: "PercentSquare",
  PiSquare: "PiSquare",
  PieChart: "PieChart",
  PilcrowSquare: "PilcrowSquare",
  PlayCircle: "PlayCircle",
  PlaySquare: "PlaySquare",
  PlugZap2: "PlugZap2",
  PlusCircle: "PlusCircle",
  PlusSquare: "PlusSquare",
  PowerCircle: "PowerCircle",
  PowerSquare: "PowerSquare",
  ScatterChart: "ScatterChart",
  School2: "School2",
  ScissorsSquareDashedBottom: "ScissorsSquareDashedBottom",
  ScissorsSquare: "ScissorsSquare",
  SigmaSquare: "SigmaSquare",
  SlashSquare: "SlashSquare",
  Sliders: "Sliders",
  SplitSquareHorizontal: "SplitSquareHorizontal",
  SplitSquareVertical: "SplitSquareVertical",
  StarFull: "StarFull",
  StopCircle: "StopCircle",
  Subtitles: "Subtitles",
  TerminalSquare: "TerminalSquare",
  TestTube2: "TestTube2",
  Tv2: "Tv2",
  UnlockKeyhole: "UnlockKeyhole",
  Unlock: "Unlock",
  UploadCloud: "UploadCloud",
  Wallet2: "Wallet2",
  Wand2: "Wand2",
  XCircle: "XCircle",
  XOctagon: "XOctagon",
  XSquare: "XSquare",
  AArrowDown: "AArrowDown",
  AArrowUp: "AArrowUp",
  ALargeSmall: "ALargeSmall",
  Accessibility: "Accessibility",
  Activity: "Activity",
  AirVent: "AirVent",
  Airplay: "Airplay",
  AlarmClockCheck: "AlarmClockCheck",
  AlarmClockMinus: "AlarmClockMinus",
  AlarmClockOff: "AlarmClockOff",
  AlarmClockPlus: "AlarmClockPlus",
  AlarmClock: "AlarmClock",
  AlarmSmoke: "AlarmSmoke",
  Album: "Album",
  AlignCenterHorizontal: "AlignCenterHorizontal",
  AlignCenterVertical: "AlignCenterVertical",
  AlignCenter: "AlignCenter",
  AlignEndHorizontal: "AlignEndHorizontal",
  AlignEndVertical: "AlignEndVertical",
  AlignHorizontalDistributeCenter: "AlignHorizontalDistributeCenter",
  AlignHorizontalDistributeEnd: "AlignHorizontalDistributeEnd",
  AlignHorizontalDistributeStart: "AlignHorizontalDistributeStart",
  AlignHorizontalJustifyCenter: "AlignHorizontalJustifyCenter",
  AlignHorizontalJustifyEnd: "AlignHorizontalJustifyEnd",
  AlignHorizontalJustifyStart: "AlignHorizontalJustifyStart",
  AlignHorizontalSpaceAround: "AlignHorizontalSpaceAround",
  AlignHorizontalSpaceBetween: "AlignHorizontalSpaceBetween",
  AlignJustify: "AlignJustify",
  AlignLeft: "AlignLeft",
  AlignRight: "AlignRight",
  AlignStartHorizontal: "AlignStartHorizontal",
  AlignStartVertical: "AlignStartVertical",
  AlignVerticalDistributeCenter: "AlignVerticalDistributeCenter",
  AlignVerticalDistributeEnd: "AlignVerticalDistributeEnd",
  AlignVerticalDistributeStart: "AlignVerticalDistributeStart",
  AlignVerticalJustifyCenter: "AlignVerticalJustifyCenter",
  AlignVerticalJustifyEnd: "AlignVerticalJustifyEnd",
  AlignVerticalJustifyStart: "AlignVerticalJustifyStart",
  AlignVerticalSpaceAround: "AlignVerticalSpaceAround",
  AlignVerticalSpaceBetween: "AlignVerticalSpaceBetween",
  Ambulance: "Ambulance",
  Ampersand: "Ampersand",
  Ampersands: "Ampersands",
  Amphora: "Amphora",
  Anchor: "Anchor",
  Angry: "Angry",
  Annoyed: "Annoyed",
  Antenna: "Antenna",
  Anvil: "Anvil",
  Aperture: "Aperture",
  AppWindowMac: "AppWindowMac",
  AppWindow: "AppWindow",
  Apple: "Apple",
  ArchiveRestore: "ArchiveRestore",
  ArchiveX: "ArchiveX",
  Archive: "Archive",
  Armchair: "Armchair",
  ArrowBigDownDash: "ArrowBigDownDash",
  ArrowBigDown: "ArrowBigDown",
  ArrowBigLeftDash: "ArrowBigLeftDash",
  ArrowBigLeft: "ArrowBigLeft",
  ArrowBigRightDash: "ArrowBigRightDash",
  ArrowBigRight: "ArrowBigRight",
  ArrowBigUpDash: "ArrowBigUpDash",
  ArrowBigUp: "ArrowBigUp",
  ArrowDown01: "ArrowDown01",
  ArrowDown10: "ArrowDown10",
  ArrowDownAZ: "ArrowDownAZ",
  ArrowDownFromLine: "ArrowDownFromLine",
  ArrowDownLeft: "ArrowDownLeft",
  ArrowDownNarrowWide: "ArrowDownNarrowWide",
  ArrowDownRight: "ArrowDownRight",
  ArrowDownToDot: "ArrowDownToDot",
  ArrowDownToLine: "ArrowDownToLine",
  ArrowDownUp: "ArrowDownUp",
  ArrowDownWideNarrow: "ArrowDownWideNarrow",
  ArrowDownZA: "ArrowDownZA",
  ArrowDown: "ArrowDown",
  ArrowLeftFromLine: "ArrowLeftFromLine",
  ArrowLeftRight: "ArrowLeftRight",
  ArrowLeftToLine: "ArrowLeftToLine",
  ArrowLeft: "ArrowLeft",
  ArrowRightFromLine: "ArrowRightFromLine",
  ArrowRightLeft: "ArrowRightLeft",
  ArrowRightToLine: "ArrowRightToLine",
  ArrowRight: "ArrowRight",
  ArrowUp01: "ArrowUp01",
  ArrowUp10: "ArrowUp10",
  ArrowUpAZ: "ArrowUpAZ",
  ArrowUpDown: "ArrowUpDown",
  ArrowUpFromDot: "ArrowUpFromDot",
  ArrowUpFromLine: "ArrowUpFromLine",
  ArrowUpLeft: "ArrowUpLeft",
  ArrowUpNarrowWide: "ArrowUpNarrowWide",
  ArrowUpRight: "ArrowUpRight",
  ArrowUpToLine: "ArrowUpToLine",
  ArrowUpWideNarrow: "ArrowUpWideNarrow",
  ArrowUpZA: "ArrowUpZA",
  ArrowUp: "ArrowUp",
  ArrowsUpFromLine: "ArrowsUpFromLine",
  Asterisk: "Asterisk",
  AtSign: "AtSign",
  Atom: "Atom",
  AudioLines: "AudioLines",
  AudioWaveform: "AudioWaveform",
  Award: "Award",
  Axe: "Axe",
  Axis3d: "Axis3d",
  Baby: "Baby",
  Backpack: "Backpack",
  BadgeAlert: "BadgeAlert",
  BadgeCent: "BadgeCent",
  BadgeCheck: "BadgeCheck",
  BadgeDollarSign: "BadgeDollarSign",
  BadgeEuro: "BadgeEuro",
  BadgeHelp: "BadgeHelp",
  BadgeIndianRupee: "BadgeIndianRupee",
  BadgeInfo: "BadgeInfo",
  BadgeJapaneseYen: "BadgeJapaneseYen",
  BadgeMinus: "BadgeMinus",
  BadgePercent: "BadgePercent",
  BadgePlus: "BadgePlus",
  BadgePoundSterling: "BadgePoundSterling",
  BadgeRussianRuble: "BadgeRussianRuble",
  BadgeSwissFranc: "BadgeSwissFranc",
  BadgeX: "BadgeX",
  Badge: "Badge",
  BaggageClaim: "BaggageClaim",
  Ban: "Ban",
  Banana: "Banana",
  Bandage: "Bandage",
  BanknoteArrowDown: "BanknoteArrowDown",
  BanknoteArrowUp: "BanknoteArrowUp",
  BanknoteX: "BanknoteX",
  Banknote: "Banknote",
  Barcode: "Barcode",
  Baseline: "Baseline",
  Bath: "Bath",
  BatteryCharging: "BatteryCharging",
  BatteryFull: "BatteryFull",
  BatteryLow: "BatteryLow",
  BatteryMedium: "BatteryMedium",
  BatteryPlus: "BatteryPlus",
  BatteryWarning: "BatteryWarning",
  Battery: "Battery",
  Beaker: "Beaker",
  BeanOff: "BeanOff",
  Bean: "Bean",
  BedDouble: "BedDouble",
  BedSingle: "BedSingle",
  Bed: "Bed",
  Beef: "Beef",
  BeerOff: "BeerOff",
  Beer: "Beer",
  BellDot: "BellDot",
  BellElectric: "BellElectric",
  BellMinus: "BellMinus",
  BellOff: "BellOff",
  BellPlus: "BellPlus",
  BellRing: "BellRing",
  Bell: "Bell",
  BetweenHorizontalEnd: "BetweenHorizontalEnd",
  BetweenHorizontalStart: "BetweenHorizontalStart",
  BetweenVerticalEnd: "BetweenVerticalEnd",
  BetweenVerticalStart: "BetweenVerticalStart",
  BicepsFlexed: "BicepsFlexed",
  Bike: "Bike",
  Binary: "Binary",
  Binoculars: "Binoculars",
  Biohazard: "Biohazard",
  Bird: "Bird",
  Bitcoin: "Bitcoin",
  Blend: "Blend",
  Blinds: "Blinds",
  Blocks: "Blocks",
  BluetoothConnected: "BluetoothConnected",
  BluetoothOff: "BluetoothOff",
  BluetoothSearching: "BluetoothSearching",
  Bluetooth: "Bluetooth",
  Bold: "Bold",
  Bolt: "Bolt",
  Bomb: "Bomb",
  Bone: "Bone",
  BookA: "BookA",
  BookAudio: "BookAudio",
  BookCheck: "BookCheck",
  BookCopy: "BookCopy",
  BookDashed: "BookDashed",
  BookDown: "BookDown",
  BookHeadphones: "BookHeadphones",
  BookHeart: "BookHeart",
  BookImage: "BookImage",
  BookKey: "BookKey",
  BookLock: "BookLock",
  BookMarked: "BookMarked",
  BookMinus: "BookMinus",
  BookOpenCheck: "BookOpenCheck",
  BookOpenText: "BookOpenText",
  BookOpen: "BookOpen",
  BookPlus: "BookPlus",
  BookText: "BookText",
  BookType: "BookType",
  BookUp2: "BookUp2",
  BookUp: "BookUp",
  BookUser: "BookUser",
  BookX: "BookX",
  Book: "Book",
  BookmarkCheck: "BookmarkCheck",
  BookmarkMinus: "BookmarkMinus",
  BookmarkPlus: "BookmarkPlus",
  BookmarkX: "BookmarkX",
  Bookmark: "Bookmark",
  BoomBox: "BoomBox",
  BotMessageSquare: "BotMessageSquare",
  BotOff: "BotOff",
  Bot: "Bot",
  BowArrow: "BowArrow",
  Box: "Box",
  Boxes: "Boxes",
  Braces: "Braces",
  Brackets: "Brackets",
  BrainCircuit: "BrainCircuit",
  BrainCog: "BrainCog",
  Brain: "Brain",
  BrickWallFire: "BrickWallFire",
  BrickWall: "BrickWall",
  BriefcaseBusiness: "BriefcaseBusiness",
  BriefcaseConveyorBelt: "BriefcaseConveyorBelt",
  BriefcaseMedical: "BriefcaseMedical",
  Briefcase: "Briefcase",
  BringToFront: "BringToFront",
  BrushCleaning: "BrushCleaning",
  Brush: "Brush",
  Bubbles: "Bubbles",
  BugOff: "BugOff",
  BugPlay: "BugPlay",
  Bug: "Bug",
  Building2: "Building2",
  Building: "Building",
  BusFront: "BusFront",
  Bus: "Bus",
  CableCar: "CableCar",
  Cable: "Cable",
  CakeSlice: "CakeSlice",
  Cake: "Cake",
  Calculator: "Calculator",
  Calendar1: "Calendar1",
  CalendarArrowDown: "CalendarArrowDown",
  CalendarArrowUp: "CalendarArrowUp",
  CalendarCheck2: "CalendarCheck2",
  CalendarCheck: "CalendarCheck",
  CalendarClock: "CalendarClock",
  CalendarCog: "CalendarCog",
  CalendarDays: "CalendarDays",
  CalendarFold: "CalendarFold",
  CalendarHeart: "CalendarHeart",
  CalendarMinus2: "CalendarMinus2",
  CalendarMinus: "CalendarMinus",
  CalendarOff: "CalendarOff",
  CalendarPlus2: "CalendarPlus2",
  CalendarPlus: "CalendarPlus",
  CalendarRange: "CalendarRange",
  CalendarSearch: "CalendarSearch",
  CalendarSync: "CalendarSync",
  CalendarX2: "CalendarX2",
  CalendarX: "CalendarX",
  Calendar: "Calendar",
  CameraOff: "CameraOff",
  Camera: "Camera",
  CandyCane: "CandyCane",
  CandyOff: "CandyOff",
  Candy: "Candy",
  Cannabis: "Cannabis",
  CaptionsOff: "CaptionsOff",
  Captions: "Captions",
  CarFront: "CarFront",
  CarTaxiFront: "CarTaxiFront",
  Car: "Car",
  Caravan: "Caravan",
  Carrot: "Carrot",
  CaseLower: "CaseLower",
  CaseSensitive: "CaseSensitive",
  CaseUpper: "CaseUpper",
  CassetteTape: "CassetteTape",
  Cast: "Cast",
  Castle: "Castle",
  Cat: "Cat",
  Cctv: "Cctv",
  ChartArea: "ChartArea",
  ChartBarBig: "ChartBarBig",
  ChartBarDecreasing: "ChartBarDecreasing",
  ChartBarIncreasing: "ChartBarIncreasing",
  ChartBarStacked: "ChartBarStacked",
  ChartBar: "ChartBar",
  ChartCandlestick: "ChartCandlestick",
  ChartColumnBig: "ChartColumnBig",
  ChartColumnDecreasing: "ChartColumnDecreasing",
  ChartColumnIncreasing: "ChartColumnIncreasing",
  ChartColumnStacked: "ChartColumnStacked",
  ChartColumn: "ChartColumn",
  ChartGantt: "ChartGantt",
  ChartLine: "ChartLine",
  ChartNetwork: "ChartNetwork",
  ChartNoAxesColumnDecreasing: "ChartNoAxesColumnDecreasing",
  ChartNoAxesColumnIncreasing: "ChartNoAxesColumnIncreasing",
  ChartNoAxesColumn: "ChartNoAxesColumn",
  ChartNoAxesCombined: "ChartNoAxesCombined",
  ChartNoAxesGantt: "ChartNoAxesGantt",
  ChartPie: "ChartPie",
  ChartScatter: "ChartScatter",
  ChartSpline: "ChartSpline",
  CheckCheck: "CheckCheck",
  Check: "Check",
  ChefHat: "ChefHat",
  Cherry: "Cherry",
  ChevronDown: "ChevronDown",
  ChevronFirst: "ChevronFirst",
  ChevronLast: "ChevronLast",
  ChevronLeft: "ChevronLeft",
  ChevronRight: "ChevronRight",
  ChevronUp: "ChevronUp",
  ChevronsDownUp: "ChevronsDownUp",
  ChevronsDown: "ChevronsDown",
  ChevronsLeftRightEllipsis: "ChevronsLeftRightEllipsis",
  ChevronsLeftRight: "ChevronsLeftRight",
  ChevronsLeft: "ChevronsLeft",
  ChevronsRightLeft: "ChevronsRightLeft",
  ChevronsRight: "ChevronsRight",
  ChevronsUpDown: "ChevronsUpDown",
  ChevronsUp: "ChevronsUp",
  Chrome: "Chrome",
  Church: "Church",
  CigaretteOff: "CigaretteOff",
  Cigarette: "Cigarette",
  CircleAlert: "CircleAlert",
  CircleArrowDown: "CircleArrowDown",
  CircleArrowLeft: "CircleArrowLeft",
  CircleArrowOutDownLeft: "CircleArrowOutDownLeft",
  CircleArrowOutDownRight: "CircleArrowOutDownRight",
  CircleArrowOutUpLeft: "CircleArrowOutUpLeft",
  CircleArrowOutUpRight: "CircleArrowOutUpRight",
  CircleArrowRight: "CircleArrowRight",
  CircleArrowUp: "CircleArrowUp",
  CircleCheckBig: "CircleCheckBig",
  CircleCheck: "CircleCheck",
  CircleChevronDown: "CircleChevronDown",
  CircleChevronLeft: "CircleChevronLeft",
  CircleChevronRight: "CircleChevronRight",
  CircleChevronUp: "CircleChevronUp",
  CircleDashed: "CircleDashed",
  CircleDivide: "CircleDivide",
  CircleDollarSign: "CircleDollarSign",
  CircleDotDashed: "CircleDotDashed",
  CircleDot: "CircleDot",
  CircleEllipsis: "CircleEllipsis",
  CircleEqual: "CircleEqual",
  CircleFadingArrowUp: "CircleFadingArrowUp",
  CircleFadingPlus: "CircleFadingPlus",
  CircleGauge: "CircleGauge",
  CircleHelp: "CircleHelp",
  CircleMinus: "CircleMinus",
  CircleOff: "CircleOff",
  CircleParkingOff: "CircleParkingOff",
  CircleParking: "CircleParking",
  CirclePause: "CirclePause",
  CirclePercent: "CirclePercent",
  CirclePlay: "CirclePlay",
  CirclePlus: "CirclePlus",
  CirclePower: "CirclePower",
  CircleSlash2: "CircleSlash2",
  CircleSlash: "CircleSlash",
  CircleSmall: "CircleSmall",
  CircleStop: "CircleStop",
  CircleUserRound: "CircleUserRound",
  CircleUser: "CircleUser",
  CircleX: "CircleX",
  Circle: "Circle",
  CircuitBoard: "CircuitBoard",
  Citrus: "Citrus",
  Clapperboard: "Clapperboard",
  ClipboardCheck: "ClipboardCheck",
  ClipboardCopy: "ClipboardCopy",
  ClipboardList: "ClipboardList",
  ClipboardMinus: "ClipboardMinus",
  ClipboardPaste: "ClipboardPaste",
  ClipboardPenLine: "ClipboardPenLine",
  ClipboardPen: "ClipboardPen",
  ClipboardPlus: "ClipboardPlus",
  ClipboardType: "ClipboardType",
  ClipboardX: "ClipboardX",
  Clipboard: "Clipboard",
  Clock1: "Clock1",
  Clock10: "Clock10",
  Clock11: "Clock11",
  Clock12: "Clock12",
  Clock2: "Clock2",
  Clock3: "Clock3",
  Clock4: "Clock4",
  Clock5: "Clock5",
  Clock6: "Clock6",
  Clock7: "Clock7",
  Clock8: "Clock8",
  Clock9: "Clock9",
  ClockAlert: "ClockAlert",
  ClockArrowDown: "ClockArrowDown",
  ClockArrowUp: "ClockArrowUp",
  ClockFading: "ClockFading",
  ClockPlus: "ClockPlus",
  Clock: "Clock",
  CloudAlert: "CloudAlert",
  CloudCog: "CloudCog",
  CloudDownload: "CloudDownload",
  CloudDrizzle: "CloudDrizzle",
  CloudFog: "CloudFog",
  CloudHail: "CloudHail",
  CloudLightning: "CloudLightning",
  CloudMoonRain: "CloudMoonRain",
  CloudMoon: "CloudMoon",
  CloudOff: "CloudOff",
  CloudRainWind: "CloudRainWind",
  CloudRain: "CloudRain",
  CloudSnow: "CloudSnow",
  CloudSunRain: "CloudSunRain",
  CloudSun: "CloudSun",
  CloudUpload: "CloudUpload",
  Cloud: "Cloud",
  Cloudy: "Cloudy",
  Clover: "Clover",
  Club: "Club",
  CodeXml: "CodeXml",
  Code: "Code",
  Codepen: "Codepen",
  Codesandbox: "Codesandbox",
  Coffee: "Coffee",
  Cog: "Cog",
  Coins: "Coins",
  Columns2: "Columns2",
  Columns3Cog: "Columns3Cog",
  Columns3: "Columns3",
  Columns4: "Columns4",
  Combine: "Combine",
  Command: "Command",
  Compass: "Compass",
  Component: "Component",
  Computer: "Computer",
  ConciergeBell: "ConciergeBell",
  Cone: "Cone",
  Construction: "Construction",
  ContactRound: "ContactRound",
  Contact: "Contact",
  Container: "Container",
  Contrast: "Contrast",
  Cookie: "Cookie",
  CookingPot: "CookingPot",
  CopyCheck: "CopyCheck",
  CopyMinus: "CopyMinus",
  CopyPlus: "CopyPlus",
  CopySlash: "CopySlash",
  CopyX: "CopyX",
  Copy: "Copy",
  Copyleft: "Copyleft",
  Copyright: "Copyright",
  CornerDownLeft: "CornerDownLeft",
  CornerDownRight: "CornerDownRight",
  CornerLeftDown: "CornerLeftDown",
  CornerLeftUp: "CornerLeftUp",
  CornerRightDown: "CornerRightDown",
  CornerRightUp: "CornerRightUp",
  CornerUpLeft: "CornerUpLeft",
  CornerUpRight: "CornerUpRight",
  Cpu: "Cpu",
  CreativeCommons: "CreativeCommons",
  CreditCard: "CreditCard",
  Croissant: "Croissant",
  Crop: "Crop",
  Cross: "Cross",
  Crosshair: "Crosshair",
  Crown: "Crown",
  Cuboid: "Cuboid",
  CupSoda: "CupSoda",
  Currency: "Currency",
  Cylinder: "Cylinder",
  Dam: "Dam",
  DatabaseBackup: "DatabaseBackup",
  DatabaseZap: "DatabaseZap",
  Database: "Database",
  DecimalsArrowLeft: "DecimalsArrowLeft",
  DecimalsArrowRight: "DecimalsArrowRight",
  Delete: "Delete",
  Dessert: "Dessert",
  Diameter: "Diameter",
  DiamondMinus: "DiamondMinus",
  DiamondPercent: "DiamondPercent",
  DiamondPlus: "DiamondPlus",
  Diamond: "Diamond",
  Dice1: "Dice1",
  Dice2: "Dice2",
  Dice3: "Dice3",
  Dice4: "Dice4",
  Dice5: "Dice5",
  Dice6: "Dice6",
  Dices: "Dices",
  Diff: "Diff",
  Disc2: "Disc2",
  Disc3: "Disc3",
  DiscAlbum: "DiscAlbum",
  Disc: "Disc",
  Divide: "Divide",
  DnaOff: "DnaOff",
  Dna: "Dna",
  Dock: "Dock",
  Dog: "Dog",
  DollarSign: "DollarSign",
  Donut: "Donut",
  DoorClosedLocked: "DoorClosedLocked",
  DoorClosed: "DoorClosed",
  DoorOpen: "DoorOpen",
  Dot: "Dot",
  Download: "Download",
  DraftingCompass: "DraftingCompass",
  Drama: "Drama",
  Dribbble: "Dribbble",
  Drill: "Drill",
  DropletOff: "DropletOff",
  Droplet: "Droplet",
  Droplets: "Droplets",
  Drum: "Drum",
  Drumstick: "Drumstick",
  Dumbbell: "Dumbbell",
  EarOff: "EarOff",
  Ear: "Ear",
  EarthLock: "EarthLock",
  Earth: "Earth",
  Eclipse: "Eclipse",
  EggFried: "EggFried",
  EggOff: "EggOff",
  Egg: "Egg",
  EllipsisVertical: "EllipsisVertical",
  Ellipsis: "Ellipsis",
  EqualApproximately: "EqualApproximately",
  EqualNot: "EqualNot",
  Equal: "Equal",
  Eraser: "Eraser",
  EthernetPort: "EthernetPort",
  Euro: "Euro",
  Expand: "Expand",
  ExternalLink: "ExternalLink",
  EyeClosed: "EyeClosed",
  EyeOff: "EyeOff",
  Eye: "Eye",
  Facebook: "Facebook",
  Factory: "Factory",
  Fan: "Fan",
  FastForward: "FastForward",
  Feather: "Feather",
  Fence: "Fence",
  FerrisWheel: "FerrisWheel",
  Figma: "Figma",
  FileArchive: "FileArchive",
  FileAudio2: "FileAudio2",
  FileAudio: "FileAudio",
  FileAxis3d: "FileAxis3d",
  FileBadge2: "FileBadge2",
  FileBadge: "FileBadge",
  FileBox: "FileBox",
  FileChartColumnIncreasing: "FileChartColumnIncreasing",
  FileChartColumn: "FileChartColumn",
  FileChartLine: "FileChartLine",
  FileChartPie: "FileChartPie",
  FileCheck2: "FileCheck2",
  FileCheck: "FileCheck",
  FileClock: "FileClock",
  FileCode2: "FileCode2",
  FileCode: "FileCode",
  FileCog: "FileCog",
  FileDiff: "FileDiff",
  FileDigit: "FileDigit",
  FileDown: "FileDown",
  FileHeart: "FileHeart",
  FileImage: "FileImage",
  FileInput: "FileInput",
  FileJson2: "FileJson2",
  FileJson: "FileJson",
  FileKey2: "FileKey2",
  FileKey: "FileKey",
  FileLock2: "FileLock2",
  FileLock: "FileLock",
  FileMinus2: "FileMinus2",
  FileMinus: "FileMinus",
  FileMusic: "FileMusic",
  FileOutput: "FileOutput",
  FilePenLine: "FilePenLine",
  FilePen: "FilePen",
  FilePlus2: "FilePlus2",
  FilePlus: "FilePlus",
  FileQuestion: "FileQuestion",
  FileScan: "FileScan",
  FileSearch2: "FileSearch2",
  FileSearch: "FileSearch",
  FileSliders: "FileSliders",
  FileSpreadsheet: "FileSpreadsheet",
  FileStack: "FileStack",
  FileSymlink: "FileSymlink",
  FileTerminal: "FileTerminal",
  FileText: "FileText",
  FileType2: "FileType2",
  FileType: "FileType",
  FileUp: "FileUp",
  FileUser: "FileUser",
  FileVideo2: "FileVideo2",
  FileVideo: "FileVideo",
  FileVolume2: "FileVolume2",
  FileVolume: "FileVolume",
  FileWarning: "FileWarning",
  FileX2: "FileX2",
  FileX: "FileX",
  File: "File",
  Files: "Files",
  Film: "Film",
  Fingerprint: "Fingerprint",
  FireExtinguisher: "FireExtinguisher",
  FishOff: "FishOff",
  FishSymbol: "FishSymbol",
  Fish: "Fish",
  FlagOff: "FlagOff",
  FlagTriangleLeft: "FlagTriangleLeft",
  FlagTriangleRight: "FlagTriangleRight",
  Flag: "Flag",
  FlameKindling: "FlameKindling",
  Flame: "Flame",
  FlashlightOff: "FlashlightOff",
  Flashlight: "Flashlight",
  FlaskConicalOff: "FlaskConicalOff",
  FlaskConical: "FlaskConical",
  FlaskRound: "FlaskRound",
  FlipHorizontal2: "FlipHorizontal2",
  FlipHorizontal: "FlipHorizontal",
  FlipVertical2: "FlipVertical2",
  FlipVertical: "FlipVertical",
  Flower2: "Flower2",
  Flower: "Flower",
  Focus: "Focus",
  FoldHorizontal: "FoldHorizontal",
  FoldVertical: "FoldVertical",
  FolderArchive: "FolderArchive",
  FolderCheck: "FolderCheck",
  FolderClock: "FolderClock",
  FolderClosed: "FolderClosed",
  FolderCode: "FolderCode",
  FolderCog: "FolderCog",
  FolderDot: "FolderDot",
  FolderDown: "FolderDown",
  FolderGit2: "FolderGit2",
  FolderGit: "FolderGit",
  FolderHeart: "FolderHeart",
  FolderInput: "FolderInput",
  FolderKanban: "FolderKanban",
  FolderKey: "FolderKey",
  FolderLock: "FolderLock",
  FolderMinus: "FolderMinus",
  FolderOpenDot: "FolderOpenDot",
  FolderOpen: "FolderOpen",
  FolderOutput: "FolderOutput",
  FolderPen: "FolderPen",
  FolderPlus: "FolderPlus",
  FolderRoot: "FolderRoot",
  FolderSearch2: "FolderSearch2",
  FolderSearch: "FolderSearch",
  FolderSymlink: "FolderSymlink",
  FolderSync: "FolderSync",
  FolderTree: "FolderTree",
  FolderUp: "FolderUp",
  FolderX: "FolderX",
  Folder: "Folder",
  Folders: "Folders",
  Footprints: "Footprints",
  Forklift: "Forklift",
  Forward: "Forward",
  Frame: "Frame",
  Framer: "Framer",
  Frown: "Frown",
  Fuel: "Fuel",
  Fullscreen: "Fullscreen",
  FunnelPlus: "FunnelPlus",
  FunnelX: "FunnelX",
  Funnel: "Funnel",
  GalleryHorizontalEnd: "GalleryHorizontalEnd",
  GalleryHorizontal: "GalleryHorizontal",
  GalleryThumbnails: "GalleryThumbnails",
  GalleryVerticalEnd: "GalleryVerticalEnd",
  GalleryVertical: "GalleryVertical",
  Gamepad2: "Gamepad2",
  Gamepad: "Gamepad",
  Gauge: "Gauge",
  Gavel: "Gavel",
  Gem: "Gem",
  Ghost: "Ghost",
  Gift: "Gift",
  GitBranchPlus: "GitBranchPlus",
  GitBranch: "GitBranch",
  GitCommitHorizontal: "GitCommitHorizontal",
  GitCommitVertical: "GitCommitVertical",
  GitCompareArrows: "GitCompareArrows",
  GitCompare: "GitCompare",
  GitFork: "GitFork",
  GitGraph: "GitGraph",
  GitMerge: "GitMerge",
  GitPullRequestArrow: "GitPullRequestArrow",
  GitPullRequestClosed: "GitPullRequestClosed",
  GitPullRequestCreateArrow: "GitPullRequestCreateArrow",
  GitPullRequestCreate: "GitPullRequestCreate",
  GitPullRequestDraft: "GitPullRequestDraft",
  GitPullRequest: "GitPullRequest",
  Github: "Github",
  Gitlab: "Gitlab",
  GlassWater: "GlassWater",
  Glasses: "Glasses",
  GlobeLock: "GlobeLock",
  Globe: "Globe",
  Goal: "Goal",
  Grab: "Grab",
  GraduationCap: "GraduationCap",
  Grape: "Grape",
  Grid2x2Check: "Grid2x2Check",
  Grid2x2Plus: "Grid2x2Plus",
  Grid2x2X: "Grid2x2X",
  Grid2x2: "Grid2x2",
  Grid3x3: "Grid3x3",
  GripHorizontal: "GripHorizontal",
  GripVertical: "GripVertical",
  Grip: "Grip",
  Group: "Group",
  Guitar: "Guitar",
  Ham: "Ham",
  Hamburger: "Hamburger",
  Hammer: "Hammer",
  HandCoins: "HandCoins",
  HandHeart: "HandHeart",
  HandHelping: "HandHelping",
  HandMetal: "HandMetal",
  HandPlatter: "HandPlatter",
  Hand: "Hand",
  Handshake: "Handshake",
  HardDriveDownload: "HardDriveDownload",
  HardDriveUpload: "HardDriveUpload",
  HardDrive: "HardDrive",
  HardHat: "HardHat",
  Hash: "Hash",
  Haze: "Haze",
  HdmiPort: "HdmiPort",
  Heading1: "Heading1",
  Heading2: "Heading2",
  Heading3: "Heading3",
  Heading4: "Heading4",
  Heading5: "Heading5",
  Heading6: "Heading6",
  Heading: "Heading",
  HeadphoneOff: "HeadphoneOff",
  Headphones: "Headphones",
  Headset: "Headset",
  HeartCrack: "HeartCrack",
  HeartHandshake: "HeartHandshake",
  HeartMinus: "HeartMinus",
  HeartOff: "HeartOff",
  HeartPlus: "HeartPlus",
  HeartPulse: "HeartPulse",
  Heart: "Heart",
  Heater: "Heater",
  Hexagon: "Hexagon",
  Highlighter: "Highlighter",
  History: "History",
  HopOff: "HopOff",
  Hop: "Hop",
  Hospital: "Hospital",
  Hotel: "Hotel",
  Hourglass: "Hourglass",
  HousePlug: "HousePlug",
  HousePlus: "HousePlus",
  HouseWifi: "HouseWifi",
  House: "House",
  IceCreamBowl: "IceCreamBowl",
  IceCreamCone: "IceCreamCone",
  IdCard: "IdCard",
  ImageDown: "ImageDown",
  ImageMinus: "ImageMinus",
  ImageOff: "ImageOff",
  ImagePlay: "ImagePlay",
  ImagePlus: "ImagePlus",
  ImageUp: "ImageUp",
  ImageUpscale: "ImageUpscale",
  Image: "Image",
  Images: "Images",
  Import: "Import",
  Inbox: "Inbox",
  IndentDecrease: "IndentDecrease",
  IndentIncrease: "IndentIncrease",
  IndianRupee: "IndianRupee",
  Infinity: "Infinity",
  Info: "Info",
  InspectionPanel: "InspectionPanel",
  Instagram: "Instagram",
  Italic: "Italic",
  IterationCcw: "IterationCcw",
  IterationCw: "IterationCw",
  JapaneseYen: "JapaneseYen",
  Joystick: "Joystick",
  Kanban: "Kanban",
  KeyRound: "KeyRound",
  KeySquare: "KeySquare",
  Key: "Key",
  KeyboardMusic: "KeyboardMusic",
  KeyboardOff: "KeyboardOff",
  Keyboard: "Keyboard",
  LampCeiling: "LampCeiling",
  LampDesk: "LampDesk",
  LampFloor: "LampFloor",
  LampWallDown: "LampWallDown",
  LampWallUp: "LampWallUp",
  Lamp: "Lamp",
  LandPlot: "LandPlot",
  Landmark: "Landmark",
  Languages: "Languages",
  LaptopMinimalCheck: "LaptopMinimalCheck",
  LaptopMinimal: "LaptopMinimal",
  Laptop: "Laptop",
  LassoSelect: "LassoSelect",
  Lasso: "Lasso",
  Laugh: "Laugh",
  Layers2: "Layers2",
  Layers: "Layers",
  LayoutDashboard: "LayoutDashboard",
  LayoutGrid: "LayoutGrid",
  LayoutList: "LayoutList",
  LayoutPanelLeft: "LayoutPanelLeft",
  LayoutPanelTop: "LayoutPanelTop",
  LayoutTemplate: "LayoutTemplate",
  Leaf: "Leaf",
  LeafyGreen: "LeafyGreen",
  Lectern: "Lectern",
  LetterText: "LetterText",
  LibraryBig: "LibraryBig",
  Library: "Library",
  LifeBuoy: "LifeBuoy",
  Ligature: "Ligature",
  LightbulbOff: "LightbulbOff",
  Lightbulb: "Lightbulb",
  Link2Off: "Link2Off",
  Link2: "Link2",
  Link: "Link",
  Linkedin: "Linkedin",
  ListCheck: "ListCheck",
  ListChecks: "ListChecks",
  ListCollapse: "ListCollapse",
  ListEnd: "ListEnd",
  ListFilterPlus: "ListFilterPlus",
  ListFilter: "ListFilter",
  ListMinus: "ListMinus",
  ListMusic: "ListMusic",
  ListOrdered: "ListOrdered",
  ListPlus: "ListPlus",
  ListRestart: "ListRestart",
  ListStart: "ListStart",
  ListTodo: "ListTodo",
  ListTree: "ListTree",
  ListVideo: "ListVideo",
  ListX: "ListX",
  List: "List",
  LoaderCircle: "LoaderCircle",
  LoaderPinwheel: "LoaderPinwheel",
  Loader: "Loader",
  LocateFixed: "LocateFixed",
  LocateOff: "LocateOff",
  Locate: "Locate",
  LocationEdit: "LocationEdit",
  LockKeyholeOpen: "LockKeyholeOpen",
  LockKeyhole: "LockKeyhole",
  LockOpen: "LockOpen",
  Lock: "Lock",
  LogIn: "LogIn",
  LogOut: "LogOut",
  Logs: "Logs",
  Lollipop: "Lollipop",
  Luggage: "Luggage",
  Magnet: "Magnet",
  MailCheck: "MailCheck",
  MailMinus: "MailMinus",
  MailOpen: "MailOpen",
  MailPlus: "MailPlus",
  MailQuestion: "MailQuestion",
  MailSearch: "MailSearch",
  MailWarning: "MailWarning",
  MailX: "MailX",
  Mail: "Mail",
  Mailbox: "Mailbox",
  Mails: "Mails",
  MapPinCheckInside: "MapPinCheckInside",
  MapPinCheck: "MapPinCheck",
  MapPinHouse: "MapPinHouse",
  MapPinMinusInside: "MapPinMinusInside",
  MapPinMinus: "MapPinMinus",
  MapPinOff: "MapPinOff",
  MapPinPlusInside: "MapPinPlusInside",
  MapPinPlus: "MapPinPlus",
  MapPinXInside: "MapPinXInside",
  MapPinX: "MapPinX",
  MapPin: "MapPin",
  MapPinned: "MapPinned",
  MapPlus: "MapPlus",
  Map: "Map",
  MarsStroke: "MarsStroke",
  Mars: "Mars",
  Martini: "Martini",
  Maximize2: "Maximize2",
  Maximize: "Maximize",
  Medal: "Medal",
  MegaphoneOff: "MegaphoneOff",
  Megaphone: "Megaphone",
  Meh: "Meh",
  MemoryStick: "MemoryStick",
  Menu: "Menu",
  Merge: "Merge",
  MessageCircleCode: "MessageCircleCode",
  MessageCircleDashed: "MessageCircleDashed",
  MessageCircleHeart: "MessageCircleHeart",
  MessageCircleMore: "MessageCircleMore",
  MessageCircleOff: "MessageCircleOff",
  MessageCirclePlus: "MessageCirclePlus",
  MessageCircleQuestion: "MessageCircleQuestion",
  MessageCircleReply: "MessageCircleReply",
  MessageCircleWarning: "MessageCircleWarning",
  MessageCircleX: "MessageCircleX",
  MessageCircle: "MessageCircle",
  MessageSquareCode: "MessageSquareCode",
  MessageSquareDashed: "MessageSquareDashed",
  MessageSquareDiff: "MessageSquareDiff",
  MessageSquareDot: "MessageSquareDot",
  MessageSquareHeart: "MessageSquareHeart",
  MessageSquareLock: "MessageSquareLock",
  MessageSquareMore: "MessageSquareMore",
  MessageSquareOff: "MessageSquareOff",
  MessageSquarePlus: "MessageSquarePlus",
  MessageSquareQuote: "MessageSquareQuote",
  MessageSquareReply: "MessageSquareReply",
  MessageSquareShare: "MessageSquareShare",
  MessageSquareText: "MessageSquareText",
  MessageSquareWarning: "MessageSquareWarning",
  MessageSquareX: "MessageSquareX",
  MessageSquare: "MessageSquare",
  MessagesSquare: "MessagesSquare",
  MicOff: "MicOff",
  MicVocal: "MicVocal",
  Mic: "Mic",
  Microchip: "Microchip",
  Microscope: "Microscope",
  Microwave: "Microwave",
  Milestone: "Milestone",
  MilkOff: "MilkOff",
  Milk: "Milk",
  Minimize2: "Minimize2",
  Minimize: "Minimize",
  Minus: "Minus",
  MonitorCheck: "MonitorCheck",
  MonitorCog: "MonitorCog",
  MonitorDot: "MonitorDot",
  MonitorDown: "MonitorDown",
  MonitorOff: "MonitorOff",
  MonitorPause: "MonitorPause",
  MonitorPlay: "MonitorPlay",
  MonitorSmartphone: "MonitorSmartphone",
  MonitorSpeaker: "MonitorSpeaker",
  MonitorStop: "MonitorStop",
  MonitorUp: "MonitorUp",
  MonitorX: "MonitorX",
  Monitor: "Monitor",
  MoonStar: "MoonStar",
  Moon: "Moon",
  MountainSnow: "MountainSnow",
  Mountain: "Mountain",
  MouseOff: "MouseOff",
  MousePointer2: "MousePointer2",
  MousePointerBan: "MousePointerBan",
  MousePointerClick: "MousePointerClick",
  MousePointer: "MousePointer",
  Mouse: "Mouse",
  Move3d: "Move3d",
  MoveDiagonal2: "MoveDiagonal2",
  MoveDiagonal: "MoveDiagonal",
  MoveDownLeft: "MoveDownLeft",
  MoveDownRight: "MoveDownRight",
  MoveDown: "MoveDown",
  MoveHorizontal: "MoveHorizontal",
  MoveLeft: "MoveLeft",
  MoveRight: "MoveRight",
  MoveUpLeft: "MoveUpLeft",
  MoveUpRight: "MoveUpRight",
  MoveUp: "MoveUp",
  MoveVertical: "MoveVertical",
  Move: "Move",
  Music2: "Music2",
  Music3: "Music3",
  Music4: "Music4",
  Music: "Music",
  Navigation2Off: "Navigation2Off",
  Navigation2: "Navigation2",
  NavigationOff: "NavigationOff",
  Navigation: "Navigation",
  Network: "Network",
  Newspaper: "Newspaper",
  Nfc: "Nfc",
  NonBinary: "NonBinary",
  NotebookPen: "NotebookPen",
  NotebookTabs: "NotebookTabs",
  NotebookText: "NotebookText",
  Notebook: "Notebook",
  NotepadTextDashed: "NotepadTextDashed",
  NotepadText: "NotepadText",
  NutOff: "NutOff",
  Nut: "Nut",
  OctagonAlert: "OctagonAlert",
  OctagonMinus: "OctagonMinus",
  OctagonPause: "OctagonPause",
  OctagonX: "OctagonX",
  Octagon: "Octagon",
  Omega: "Omega",
  Option: "Option",
  Orbit: "Orbit",
  Origami: "Origami",
  Package2: "Package2",
  PackageCheck: "PackageCheck",
  PackageMinus: "PackageMinus",
  PackageOpen: "PackageOpen",
  PackagePlus: "PackagePlus",
  PackageSearch: "PackageSearch",
  PackageX: "PackageX",
  Package: "Package",
  PaintBucket: "PaintBucket",
  PaintRoller: "PaintRoller",
  PaintbrushVertical: "PaintbrushVertical",
  Paintbrush: "Paintbrush",
  Palette: "Palette",
  Panda: "Panda",
  PanelBottomClose: "PanelBottomClose",
  PanelBottomDashed: "PanelBottomDashed",
  PanelBottomOpen: "PanelBottomOpen",
  PanelBottom: "PanelBottom",
  PanelLeftClose: "PanelLeftClose",
  PanelLeftDashed: "PanelLeftDashed",
  PanelLeftOpen: "PanelLeftOpen",
  PanelLeft: "PanelLeft",
  PanelRightClose: "PanelRightClose",
  PanelRightDashed: "PanelRightDashed",
  PanelRightOpen: "PanelRightOpen",
  PanelRight: "PanelRight",
  PanelTopClose: "PanelTopClose",
  PanelTopDashed: "PanelTopDashed",
  PanelTopOpen: "PanelTopOpen",
  PanelTop: "PanelTop",
  PanelsLeftBottom: "PanelsLeftBottom",
  PanelsRightBottom: "PanelsRightBottom",
  PanelsTopLeft: "PanelsTopLeft",
  Paperclip: "Paperclip",
  Parentheses: "Parentheses",
  ParkingMeter: "ParkingMeter",
  PartyPopper: "PartyPopper",
  Pause: "Pause",
  PawPrint: "PawPrint",
  PcCase: "PcCase",
  PenLine: "PenLine",
  PenOff: "PenOff",
  PenTool: "PenTool",
  Pen: "Pen",
  PencilLine: "PencilLine",
  PencilOff: "PencilOff",
  PencilRuler: "PencilRuler",
  Pencil: "Pencil",
  Pentagon: "Pentagon",
  Percent: "Percent",
  PersonStanding: "PersonStanding",
  PhilippinePeso: "PhilippinePeso",
  PhoneCall: "PhoneCall",
  PhoneForwarded: "PhoneForwarded",
  PhoneIncoming: "PhoneIncoming",
  PhoneMissed: "PhoneMissed",
  PhoneOff: "PhoneOff",
  PhoneOutgoing: "PhoneOutgoing",
  Phone: "Phone",
  Pi: "Pi",
  Piano: "Piano",
  Pickaxe: "Pickaxe",
  PictureInPicture2: "PictureInPicture2",
  PictureInPicture: "PictureInPicture",
  PiggyBank: "PiggyBank",
  PilcrowLeft: "PilcrowLeft",
  PilcrowRight: "PilcrowRight",
  Pilcrow: "Pilcrow",
  PillBottle: "PillBottle",
  Pill: "Pill",
  PinOff: "PinOff",
  Pin: "Pin",
  Pipette: "Pipette",
  Pizza: "Pizza",
  PlaneLanding: "PlaneLanding",
  PlaneTakeoff: "PlaneTakeoff",
  Plane: "Plane",
  Play: "Play",
  Plug2: "Plug2",
  PlugZap: "PlugZap",
  Plug: "Plug",
  Plus: "Plus",
  PocketKnife: "PocketKnife",
  Pocket: "Pocket",
  Podcast: "Podcast",
  PointerOff: "PointerOff",
  Pointer: "Pointer",
  Popcorn: "Popcorn",
  Popsicle: "Popsicle",
  PoundSterling: "PoundSterling",
  PowerOff: "PowerOff",
  Power: "Power",
  Presentation: "Presentation",
  PrinterCheck: "PrinterCheck",
  Printer: "Printer",
  Projector: "Projector",
  Proportions: "Proportions",
  Puzzle: "Puzzle",
  Pyramid: "Pyramid",
  QrCode: "QrCode",
  Quote: "Quote",
  Rabbit: "Rabbit",
  Radar: "Radar",
  Radiation: "Radiation",
  Radical: "Radical",
  RadioReceiver: "RadioReceiver",
  RadioTower: "RadioTower",
  Radio: "Radio",
  Radius: "Radius",
  RailSymbol: "RailSymbol",
  Rainbow: "Rainbow",
  Rat: "Rat",
  Ratio: "Ratio",
  ReceiptCent: "ReceiptCent",
  ReceiptEuro: "ReceiptEuro",
  ReceiptIndianRupee: "ReceiptIndianRupee",
  ReceiptJapaneseYen: "ReceiptJapaneseYen",
  ReceiptPoundSterling: "ReceiptPoundSterling",
  ReceiptRussianRuble: "ReceiptRussianRuble",
  ReceiptSwissFranc: "ReceiptSwissFranc",
  ReceiptText: "ReceiptText",
  Receipt: "Receipt",
  RectangleEllipsis: "RectangleEllipsis",
  RectangleGoggles: "RectangleGoggles",
  RectangleHorizontal: "RectangleHorizontal",
  RectangleVertical: "RectangleVertical",
  Recycle: "Recycle",
  Redo2: "Redo2",
  RedoDot: "RedoDot",
  Redo: "Redo",
  RefreshCcwDot: "RefreshCcwDot",
  RefreshCcw: "RefreshCcw",
  RefreshCwOff: "RefreshCwOff",
  RefreshCw: "RefreshCw",
  Refrigerator: "Refrigerator",
  Regex: "Regex",
  RemoveFormatting: "RemoveFormatting",
  Repeat1: "Repeat1",
  Repeat2: "Repeat2",
  Repeat: "Repeat",
  ReplaceAll: "ReplaceAll",
  Replace: "Replace",
  ReplyAll: "ReplyAll",
  Reply: "Reply",
  Rewind: "Rewind",
  Ribbon: "Ribbon",
  Rocket: "Rocket",
  RockingChair: "RockingChair",
  RollerCoaster: "RollerCoaster",
  Rotate3d: "Rotate3d",
  RotateCcwKey: "RotateCcwKey",
  RotateCcwSquare: "RotateCcwSquare",
  RotateCcw: "RotateCcw",
  RotateCwSquare: "RotateCwSquare",
  RotateCw: "RotateCw",
  RouteOff: "RouteOff",
  Route: "Route",
  Router: "Router",
  Rows2: "Rows2",
  Rows3: "Rows3",
  Rows4: "Rows4",
  Rss: "Rss",
  RulerDimensionLine: "RulerDimensionLine",
  Ruler: "Ruler",
  RussianRuble: "RussianRuble",
  Sailboat: "Sailboat",
  Salad: "Salad",
  Sandwich: "Sandwich",
  SatelliteDish: "SatelliteDish",
  Satellite: "Satellite",
  SaudiRiyal: "SaudiRiyal",
  SaveAll: "SaveAll",
  SaveOff: "SaveOff",
  Save: "Save",
  Scale3d: "Scale3d",
  Scale: "Scale",
  Scaling: "Scaling",
  ScanBarcode: "ScanBarcode",
  ScanEye: "ScanEye",
  ScanFace: "ScanFace",
  ScanHeart: "ScanHeart",
  ScanLine: "ScanLine",
  ScanQrCode: "ScanQrCode",
  ScanSearch: "ScanSearch",
  ScanText: "ScanText",
  Scan: "Scan",
  School: "School",
  ScissorsLineDashed: "ScissorsLineDashed",
  Scissors: "Scissors",
  ScreenShareOff: "ScreenShareOff",
  ScreenShare: "ScreenShare",
  ScrollText: "ScrollText",
  Scroll: "Scroll",
  SearchCheck: "SearchCheck",
  SearchCode: "SearchCode",
  SearchSlash: "SearchSlash",
  SearchX: "SearchX",
  Search: "Search",
  Section: "Section",
  SendHorizontal: "SendHorizontal",
  SendToBack: "SendToBack",
  Send: "Send",
  SeparatorHorizontal: "SeparatorHorizontal",
  SeparatorVertical: "SeparatorVertical",
  ServerCog: "ServerCog",
  ServerCrash: "ServerCrash",
  ServerOff: "ServerOff",
  Server: "Server",
  Settings2: "Settings2",
  Settings: "Settings",
  Shapes: "Shapes",
  Share2: "Share2",
  Share: "Share",
  Sheet: "Sheet",
  Shell: "Shell",
  ShieldAlert: "ShieldAlert",
  ShieldBan: "ShieldBan",
  ShieldCheck: "ShieldCheck",
  ShieldEllipsis: "ShieldEllipsis",
  ShieldHalf: "ShieldHalf",
  ShieldMinus: "ShieldMinus",
  ShieldOff: "ShieldOff",
  ShieldPlus: "ShieldPlus",
  ShieldQuestion: "ShieldQuestion",
  ShieldUser: "ShieldUser",
  ShieldX: "ShieldX",
  Shield: "Shield",
  ShipWheel: "ShipWheel",
  Ship: "Ship",
  Shirt: "Shirt",
  ShoppingBag: "ShoppingBag",
  ShoppingBasket: "ShoppingBasket",
  ShoppingCart: "ShoppingCart",
  Shovel: "Shovel",
  ShowerHead: "ShowerHead",
  Shredder: "Shredder",
  Shrimp: "Shrimp",
  Shrink: "Shrink",
  Shrub: "Shrub",
  Shuffle: "Shuffle",
  Sigma: "Sigma",
  SignalHigh: "SignalHigh",
  SignalLow: "SignalLow",
  SignalMedium: "SignalMedium",
  SignalZero: "SignalZero",
  Signal: "Signal",
  Signature: "Signature",
  SignpostBig: "SignpostBig",
  Signpost: "Signpost",
  Siren: "Siren",
  SkipBack: "SkipBack",
  SkipForward: "SkipForward",
  Skull: "Skull",
  Slack: "Slack",
  Slash: "Slash",
  Slice: "Slice",
  SlidersHorizontal: "SlidersHorizontal",
  SlidersVertical: "SlidersVertical",
  SmartphoneCharging: "SmartphoneCharging",
  SmartphoneNfc: "SmartphoneNfc",
  Smartphone: "Smartphone",
  SmilePlus: "SmilePlus",
  Smile: "Smile",
  Snail: "Snail",
  Snowflake: "Snowflake",
  SoapDispenserDroplet: "SoapDispenserDroplet",
  Sofa: "Sofa",
  Soup: "Soup",
  Space: "Space",
  Spade: "Spade",
  Sparkle: "Sparkle",
  Sparkles: "Sparkles",
  Speaker: "Speaker",
  Speech: "Speech",
  SpellCheck2: "SpellCheck2",
  SpellCheck: "SpellCheck",
  SplinePointer: "SplinePointer",
  Spline: "Spline",
  Split: "Split",
  SprayCan: "SprayCan",
  Sprout: "Sprout",
  SquareActivity: "SquareActivity",
  SquareArrowDownLeft: "SquareArrowDownLeft",
  SquareArrowDownRight: "SquareArrowDownRight",
  SquareArrowDown: "SquareArrowDown",
  SquareArrowLeft: "SquareArrowLeft",
  SquareArrowOutDownLeft: "SquareArrowOutDownLeft",
  SquareArrowOutDownRight: "SquareArrowOutDownRight",
  SquareArrowOutUpLeft: "SquareArrowOutUpLeft",
  SquareArrowOutUpRight: "SquareArrowOutUpRight",
  SquareArrowRight: "SquareArrowRight",
  SquareArrowUpLeft: "SquareArrowUpLeft",
  SquareArrowUpRight: "SquareArrowUpRight",
  SquareArrowUp: "SquareArrowUp",
  SquareAsterisk: "SquareAsterisk",
  SquareBottomDashedScissors: "SquareBottomDashedScissors",
  SquareChartGantt: "SquareChartGantt",
  SquareCheckBig: "SquareCheckBig",
  SquareCheck: "SquareCheck",
  SquareChevronDown: "SquareChevronDown",
  SquareChevronLeft: "SquareChevronLeft",
  SquareChevronRight: "SquareChevronRight",
  SquareChevronUp: "SquareChevronUp",
  SquareCode: "SquareCode",
  SquareDashedBottomCode: "SquareDashedBottomCode",
  SquareDashedBottom: "SquareDashedBottom",
  SquareDashedKanban: "SquareDashedKanban",
  SquareDashedMousePointer: "SquareDashedMousePointer",
  SquareDashed: "SquareDashed",
  SquareDivide: "SquareDivide",
  SquareDot: "SquareDot",
  SquareEqual: "SquareEqual",
  SquareFunction: "SquareFunction",
  SquareKanban: "SquareKanban",
  SquareLibrary: "SquareLibrary",
  SquareM: "SquareM",
  SquareMenu: "SquareMenu",
  SquareMinus: "SquareMinus",
  SquareMousePointer: "SquareMousePointer",
  SquareParkingOff: "SquareParkingOff",
  SquareParking: "SquareParking",
  SquarePen: "SquarePen",
  SquarePercent: "SquarePercent",
  SquarePi: "SquarePi",
  SquarePilcrow: "SquarePilcrow",
  SquarePlay: "SquarePlay",
  SquarePlus: "SquarePlus",
  SquarePower: "SquarePower",
  SquareRadical: "SquareRadical",
  SquareRoundCorner: "SquareRoundCorner",
  SquareScissors: "SquareScissors",
  SquareSigma: "SquareSigma",
  SquareSlash: "SquareSlash",
  SquareSplitHorizontal: "SquareSplitHorizontal",
  SquareSplitVertical: "SquareSplitVertical",
  SquareSquare: "SquareSquare",
  SquareStack: "SquareStack",
  SquareTerminal: "SquareTerminal",
  SquareUserRound: "SquareUserRound",
  SquareUser: "SquareUser",
  SquareX: "SquareX",
  Square: "Square",
  SquaresExclude: "SquaresExclude",
  SquaresIntersect: "SquaresIntersect",
  SquaresSubtract: "SquaresSubtract",
  SquaresUnite: "SquaresUnite",
  Squircle: "Squircle",
  Squirrel: "Squirrel",
  Stamp: "Stamp",
  StarHalf: "StarHalf",
  StarOff: "StarOff",
  Star: "Star",
  StepBack: "StepBack",
  StepForward: "StepForward",
  Stethoscope: "Stethoscope",
  Sticker: "Sticker",
  StickyNote: "StickyNote",
  Store: "Store",
  StretchHorizontal: "StretchHorizontal",
  StretchVertical: "StretchVertical",
  Strikethrough: "Strikethrough",
  Subscript: "Subscript",
  SunDim: "SunDim",
  SunMedium: "SunMedium",
  SunMoon: "SunMoon",
  SunSnow: "SunSnow",
  Sun: "Sun",
  Sunrise: "Sunrise",
  Sunset: "Sunset",
  Superscript: "Superscript",
  SwatchBook: "SwatchBook",
  SwissFranc: "SwissFranc",
  SwitchCamera: "SwitchCamera",
  Sword: "Sword",
  Swords: "Swords",
  Syringe: "Syringe",
  Table2: "Table2",
  TableCellsMerge: "TableCellsMerge",
  TableCellsSplit: "TableCellsSplit",
  TableColumnsSplit: "TableColumnsSplit",
  TableOfContents: "TableOfContents",
  TableProperties: "TableProperties",
  TableRowsSplit: "TableRowsSplit",
  Table: "Table",
  TabletSmartphone: "TabletSmartphone",
  Tablet: "Tablet",
  Tablets: "Tablets",
  Tag: "Tag",
  Tags: "Tags",
  Tally1: "Tally1",
  Tally2: "Tally2",
  Tally3: "Tally3",
  Tally4: "Tally4",
  Tally5: "Tally5",
  Tangent: "Tangent",
  Target: "Target",
  Telescope: "Telescope",
  TentTree: "TentTree",
  Tent: "Tent",
  Terminal: "Terminal",
  TestTubeDiagonal: "TestTubeDiagonal",
  TestTube: "TestTube",
  TestTubes: "TestTubes",
  TextCursorInput: "TextCursorInput",
  TextCursor: "TextCursor",
  TextQuote: "TextQuote",
  TextSearch: "TextSearch",
  TextSelect: "TextSelect",
  Text: "Text",
  Theater: "Theater",
  ThermometerSnowflake: "ThermometerSnowflake",
  ThermometerSun: "ThermometerSun",
  Thermometer: "Thermometer",
  ThumbsDown: "ThumbsDown",
  ThumbsUp: "ThumbsUp",
  TicketCheck: "TicketCheck",
  TicketMinus: "TicketMinus",
  TicketPercent: "TicketPercent",
  TicketPlus: "TicketPlus",
  TicketSlash: "TicketSlash",
  TicketX: "TicketX",
  Ticket: "Ticket",
  TicketsPlane: "TicketsPlane",
  Tickets: "Tickets",
  TimerOff: "TimerOff",
  TimerReset: "TimerReset",
  Timer: "Timer",
  ToggleLeft: "ToggleLeft",
  ToggleRight: "ToggleRight",
  Toilet: "Toilet",
  Tornado: "Tornado",
  Torus: "Torus",
  TouchpadOff: "TouchpadOff",
  Touchpad: "Touchpad",
  TowerControl: "TowerControl",
  ToyBrick: "ToyBrick",
  Tractor: "Tractor",
  TrafficCone: "TrafficCone",
  TrainFrontTunnel: "TrainFrontTunnel",
  TrainFront: "TrainFront",
  TrainTrack: "TrainTrack",
  TramFront: "TramFront",
  Transgender: "Transgender",
  Trash2: "Trash2",
  Trash: "Trash",
  TreeDeciduous: "TreeDeciduous",
  TreePalm: "TreePalm",
  TreePine: "TreePine",
  Trees: "Trees",
  Trello: "Trello",
  TrendingDown: "TrendingDown",
  TrendingUpDown: "TrendingUpDown",
  TrendingUp: "TrendingUp",
  TriangleAlert: "TriangleAlert",
  TriangleDashed: "TriangleDashed",
  TriangleRight: "TriangleRight",
  Triangle: "Triangle",
  Trophy: "Trophy",
  TruckElectric: "TruckElectric",
  Truck: "Truck",
  Turtle: "Turtle",
  TvMinimalPlay: "TvMinimalPlay",
  TvMinimal: "TvMinimal",
  Tv: "Tv",
  Twitch: "Twitch",
  Twitter: "Twitter",
  TypeOutline: "TypeOutline",
  Type: "Type",
  UmbrellaOff: "UmbrellaOff",
  Umbrella: "Umbrella",
  Underline: "Underline",
  Undo2: "Undo2",
  UndoDot: "UndoDot",
  Undo: "Undo",
  UnfoldHorizontal: "UnfoldHorizontal",
  UnfoldVertical: "UnfoldVertical",
  Ungroup: "Ungroup",
  University: "University",
  Unlink2: "Unlink2",
  Unlink: "Unlink",
  Unplug: "Unplug",
  Upload: "Upload",
  Usb: "Usb",
  UserCheck: "UserCheck",
  UserCog: "UserCog",
  UserLock: "UserLock",
  UserMinus: "UserMinus",
  UserPen: "UserPen",
  UserPlus: "UserPlus",
  UserRoundCheck: "UserRoundCheck",
  UserRoundCog: "UserRoundCog",
  UserRoundMinus: "UserRoundMinus",
  UserRoundPen: "UserRoundPen",
  UserRoundPlus: "UserRoundPlus",
  UserRoundSearch: "UserRoundSearch",
  UserRoundX: "UserRoundX",
  UserRound: "UserRound",
  UserSearch: "UserSearch",
  UserX: "UserX",
  User: "User",
  UsersRound: "UsersRound",
  Users: "Users",
  UtensilsCrossed: "UtensilsCrossed",
  Utensils: "Utensils",
  UtilityPole: "UtilityPole",
  Variable: "Variable",
  Vault: "Vault",
  Vegan: "Vegan",
  VenetianMask: "VenetianMask",
  VenusAndMars: "VenusAndMars",
  Venus: "Venus",
  VibrateOff: "VibrateOff",
  Vibrate: "Vibrate",
  VideoOff: "VideoOff",
  Video: "Video",
  Videotape: "Videotape",
  View: "View",
  Voicemail: "Voicemail",
  Volleyball: "Volleyball",
  Volume1: "Volume1",
  Volume2: "Volume2",
  VolumeOff: "VolumeOff",
  VolumeX: "VolumeX",
  Volume: "Volume",
  Vote: "Vote",
  WalletCards: "WalletCards",
  WalletMinimal: "WalletMinimal",
  Wallet: "Wallet",
  Wallpaper: "Wallpaper",
  WandSparkles: "WandSparkles",
  Wand: "Wand",
  Warehouse: "Warehouse",
  WashingMachine: "WashingMachine",
  Watch: "Watch",
  WavesLadder: "WavesLadder",
  Waves: "Waves",
  Waypoints: "Waypoints",
  Webcam: "Webcam",
  WebhookOff: "WebhookOff",
  Webhook: "Webhook",
  Weight: "Weight",
  WheatOff: "WheatOff",
  Wheat: "Wheat",
  WholeWord: "WholeWord",
  WifiHigh: "WifiHigh",
  WifiLow: "WifiLow",
  WifiOff: "WifiOff",
  WifiPen: "WifiPen",
  WifiZero: "WifiZero",
  Wifi: "Wifi",
  WindArrowDown: "WindArrowDown",
  Wind: "Wind",
  WineOff: "WineOff",
  Wine: "Wine",
  Workflow: "Workflow",
  Worm: "Worm",
  WrapText: "WrapText",
  Wrench: "Wrench",
  X: "X",
  Youtube: "Youtube",
  ZapOff: "ZapOff",
  Zap: "Zap",
  ZoomIn: "ZoomIn",
  ZoomOut: "ZoomOut",
} as const;
